import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-adm-modal-validaroferta',
  templateUrl: './adm-modal-validaroferta.component.html',
  styleUrls: ['./adm-modal-validaroferta.component.css']
})
export class AdmModalValidarofertaComponent implements OnInit{
  @Output() confirm = new EventEmitter<boolean>();
  title: string;
  message: string;

  constructor(public activeModal: NgbActiveModal){}

  ngOnInit(){
  }

  dismiss() {
    this.activeModal.close();
  }
}
